<input type="number" id="pageNumber" class="toolbarField pageNumber" title="Page" value="1" size="4" min="1" data-l10n-id="page" autocomplete="off" />
<span [class]="showPagingButtons | responsiveCSSClass : 'hiddenXLView'" id="numPages" class="toolbarLabel"></span>
